<template>
  <div v-show="show" class="header-container" @mouseleave="setMenuRouter([], [], -1, -1)">
    <div class="header-body">
      <div class="header-body-img">
        <a href="https://www.xa.com/">
          <img class="header-logo" src="//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/logo.svg">
        </a>
      </div>
      <div class="header-body-tools">
        <div class="tools-router">
          <ul class="router-list">
            <li class="router-item"
            v-for="(item, index) in constantRouterMap"
            :key="index"
            v-if="item.meta.menuShow"
            style="display: block"
            @mouseenter="enterRouter(item, index)"
            @click="menuTo(item)">
            {{ $t(item.meta.name) }}
            <i v-show="item.children && item.children.length" class="iconfont icon-more-down"></i>
            </li>
          </ul>
          <div class="router-ipad">
            <img ref="ipadMenuBtn" @click="showIpadMenu()" class="ipad" src="//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/icon_more.png">
          </div>
        </div>
        <div class="tools-users">
          <div v-show="hasSignIn" class="tools-users-item notice-box">
            <i class="iconfont icon-remind" @click="toNotice()"></i>
            <div v-show="!allreadStatus" class="notice-redpoint"></div>
          </div>
          <div v-show="hasSignIn" class="tools-users-item sub-router-box">
            <img class="users-img" :src="accountImg">
            <div class="sub-router" :class="{'en_mode': lang !== 'zh'}">
              <ul class="sub-router-list">
                <li :class="{'active': routerName === 'user'}" @click="toUser()" v-if="roleClass !== 3 && roleClass !== 1"><i class="iconfont icon-account"></i>{{ $t("users.user") }}</li>
                <li :class="{'active': routerName === 'platform'}" @click="toPlatform()" v-if="roleClass !== 3 && roleClass !== 1"><i class="iconfont icon-openplartform"></i>{{ $t("users.platform") }}</li>
                <li @click="toFm()" v-if="roleClass !== 3  && roleClass !== 1" ><i class="iconfont icon-datamanagement"></i>{{ $t("users.data") }}</li>
                <li :class="{'active': routerName === 'userhome'}" @click="toUserHome()"><i class="iconfont icon-homepage"></i>{{ $t("users.homepage") }}</li>
                <li @click="toLogout()"><i class="iconfont icon-exit"></i>{{ $t("users.logout") }}</li>
              </ul>
            </div>
          </div>
          <div class="tools-users-item" v-show="!hasSignIn" @click="toSignin()">{{ $t("users.signin") }}</div>
          <div class="tools-users-item" v-show="!hasSignIn">
            <el-button class="tools-users-item-btn" @click="toSignup()">{{ $t("users.signup") }}</el-button>
          </div>
          <!-- 语言切换 -->
          <div class="tools-users-item sub-router-box lang-list">{{ $t("lang") }}
            <div class="sub-router">
              <ul class="sub-router-list">
                <li @click="langChange('zh')" :class="{'active': lang === 'zh'}"> 简体中文 </li>
                <li @click="langChange('en')" :class="{'active': lang === 'en'}"> English </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下拉的菜单栏 -->
    <div
      class="router-children-list"
      :class="{'active': menuRouter.length}"
      @mouseleave="setMenuRouter([], [], -1, -1)">
      <div
        class="router-children-layer-first"
        :class="{'with-second': menuItemRouter.length}">
        <div v-for="(menu, index) in menuRouter"
          :key="index"
          v-if="menu.meta.menuShow"
          class="router-children-item"
          :class="{'active': menuItemActiveIdx === index}"
          @mouseenter="enterItemRouter(menu.children && menu.children.length ? menu.children : [], index)"
          @click="menuTo(menu)">
          <div class="router-children-item-content">
            <div class="router-children-item-icon" v-if="menu.meta.icon">
              <img :src="'//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/' + menu.meta.icon" alt="">
            </div>
            <div class="router-children-item-text">
              <p class="name">{{ $t(menu.meta.name) }}</p>
              <p class="desc">{{ $t(menu.meta.desc) }}</p>
            </div>
          </div>
          <i v-show="menu.children && menu.children.length" class="iconfont icon-more"></i>
        </div>
      </div>
      <div v-if="menuItemRouter.length"
        class="router-children-layer-second">
        <div
          v-for="(item, index) in menuItemRouter"
          :key="index"
          v-if="item.meta.menuShow"
          class="router-children-item"
          @click="menuTo(item)">
          <div class="router-children-item-content">
            <div class="router-children-item-icon">
              <img :src="'//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/' + item.meta.icon" alt="">
            </div>
            <div class="router-children-item-text">
              <p class="name">{{ $t(item.meta.name)}}</p>
              <p class="desc">{{ $t(item.meta.desc) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 小屏幕下(<1000px) 菜单列表 -->
    <div
      v-if="ipadMenuShow"
      ref="ipadMenu"
      class="router-children-list-ipad">
      <div class="router-children-layer-ipad">
        <div
          v-for="(item, index) in constantRouterMap"
          :key="index"
          v-if="item.meta.menuShow"
          style="display: block"
          class="router-children-item">
          <div
            class="router-children-item-content"
            @click="ipadMenuTo(item, index, -1)">
            <div v-if="item.meta.icon" class="router-children-item-icon">
              <img :src="'//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/' + item.meta.icon" alt="">
            </div>
            <div class="router-children-item-text">
              {{ $t(item.meta.name) }}
            </div>
            <i v-if="item.children && item.children.length" class="iconfont icon-more-down"></i>
          </div>
          <div v-if="ipadMenuIdx === index && item.children && item.children.length"
            class="router-children-layer-ipad"
            :class="{'active': ipadMenuIdx === index}">
            <div
              v-for="(menuItem, idx) in item.children"
              :key="idx"
              v-if="menuItem.meta.menuShow"
              class="router-children-item">
              <div
                class="router-children-item-content"
                @click="ipadMenuTo(menuItem, index, idx)">
                <div v-if="menuItem.meta.icon" class="router-children-item-icon">
                  <img :src="'//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/' + menuItem.meta.icon" alt="">
                </div>
                <div class="router-children-item-text">
                  {{ $t(menuItem.meta.name) }}
                </div>
                <i v-if="menuItem.children && menuItem.children.length" class="iconfont icon-more-down"></i>
              </div>
              <div v-if="ipadMenuItemIdx === idx && menuItem.children && menuItem.children.length"
                class="router-children-layer-ipad"
                :class="{'active': ipadMenuItemIdx === idx}">
                <div
                  v-for="(menuSubItem, i) in menuItem.children"
                  :key="i"
                  v-if="menuItem.meta.menuShow"
                  class="router-children-item">
                  <div class="router-children-item-content"
                    @click="ipadMenuTo(menuSubItem, index, idx)">
                    <div v-if="menuSubItem.meta.icon" class="router-children-item-icon">
                      <img :src="'//xiot-app.oss-cn-hangzhou.aliyuncs.com/iot_home/images/common/' + menuSubItem.meta.icon" alt="">
                    </div>
                    <div class="router-children-item-text">
                      {{ $t(menuSubItem.meta.name) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 判断服务器部署环境
import { env } from '@/utils/env.config.js'
import { fmUrl } from '@/utils/constant'
import { getCookie } from '@/utils/auth'
import { mapGetters } from 'vuex'
import { constantRouterMap } from '@/router'
import { on, off } from '@/utils/dom'

export default {
  props: {
    show: false
  },
  components: {
  },
  mounted () {
    this.getUserInfo()
  },
  data () {
    return {
      constantRouterMap, // router-list
      // PC 菜单
      menuRouter: [], // 第二层子菜单层需要展示的router
      menuItemRouter: [], // 第三层子菜单展示的router
      menuActiveIdx: -1, // 第一层激活idx
      menuItemActiveIdx: -1, // 第二层激活idx
      // ipad 菜单
      ipadMenuShow: false, // 是否显示ipad菜单栏
      ipadMenuIdx: -1, // ipad 第一层菜单激活
      ipadMenuItemIdx: -1 // ipad 第二层菜单激活
    }
  },
  computed: {
    ...mapGetters([
      'hasSignIn',
      'accountImg',
      'roleClass',
      'allreadStatus',
      'routerName',
      'lang'
    ])
  },
  watch: {
    roleClass (val, oldVal) {
      this.roleClass = val
    }
  },
  methods: {
    toSignin (url = '') {
      console.log('前往登录')
      if (url) {
        this.$router.push({path: '/signin', query: {url: encodeURI(`${window.location.protocol}//${window.location.hostname}${url}`)}})
      } else {
        this.$router.push({path: '/signin', query: {redirect: this.$route.path || '/'}})
      }
    },
    toSignup () {
      console.log('前往注册')
      this.$router.push({path: '/signup'})
    },
    toUser () {
      this.$router.push({path: '/user', query: {tabIndex: '1-1'}})
    },
    toNotice () {
      this.$router.push({path: '/user', query: {tabIndex: '1-3'}})
    },
    toPlatform () {
      this.$router.push({path: '/platform'})
    },
    // 前往数据管理 fmadmin
    toFm () {
      // 权限限制
      if (this.roleClass === 3 || this.roleClass === 1) return
      // 对数据管理作特殊处理
      if (this.hasSignIn) {
        window.open(fmUrl[env], '_blank')
      } else {
        this.$router.push({path: '/signin', query: {url: encodeURI(fmUrl[env])}})
      }
    },
    toUserHome () {
      this.$router.push({path: '/user/home'})
    },
    toLogout () {
      this.$store.dispatch('logOut', {}).then(() => {
        const url = this.$route.path || ''
        this.$router.push({path: url})
        if (this.$route.path === '/user' || this.$route.path === '/user/home') { //  我的主页及账号信息页面退出时，需重新加载页面
          location.reload() // 重载页面
        }
      })
    },
    langChange (lang) {
      if (this.$i18n.locale === lang) return
      this.$i18n.locale = lang
      this.$store.dispatch('setIotLang', lang)
    },
    // 进入菜单
    enterRouter (router, menuIdx) {
      this.menuRouter = router.children && router.children.length ? router.children : []
      // 如果存在children 即存在第二层子菜单， 继续判断是否存在第三层菜单
      let menuItemRouter = []
      let menuItemActiveIdx = -1
      if (this.menuRouter.length) { // 产品/配件  --- FM1,FM2, FC2, WS7
        for (let i = 0; i < this.menuRouter.length; i++) {
          if (this.menuRouter[i].children && this.menuRouter[i].children.length) {
            menuItemRouter = this.menuRouter[i].children.slice()
            menuItemActiveIdx = i
            break
          }
        }
      }
      this.menuActiveIdx = menuIdx
      this.menuItemRouter = menuItemRouter
      this.menuItemActiveIdx = menuItemActiveIdx
    },
    // 进入子菜单
    enterItemRouter (itemRouter, idx) {
      this.menuItemRouter = itemRouter
      this.menuItemActiveIdx = itemRouter.length ? idx : -1
    },
    // 设置/清空 菜单路由表
    setMenuRouter (router, itemRouter, menuIdx, menuItemIdx) {
      this.menuActiveIdx = menuIdx
      this.menuRouter = router
      this.menuItemRouter = itemRouter
      this.menuItemActiveIdx = menuItemIdx
    },
    // 路由跳转
    menuTo (item, index = -1) {
      console.log('item', item)
      // 当前是社区页面，属于再次点击， 需要刷新社区页
      if (this.$route.name === 'community' && item.name === 'community') {
        this.$store.commit('SET_COM_ACTIVE')
      }
      if (item.children && item.children.length) return
      this.$router.push({path: item.path})
      this.doClearUserActive()
      this.setMenuRouter([], [], -1, -1)
    },
    // 显示ipad 菜单栏
    showIpadMenu () {
      this.ipadMenuShow = !this.ipadMenuShow
      this.ipadMenuIdx = -1
      this.ipadMenuItemIdx = -1
      // 注册dom事件
      on(document, 'click', this.handleDocumentClick)
      on(document, 'scroll', this.handleDocumentScroll)
    },
    // ipad菜单子项点击
    ipadMenuTo (router, menuIdx, menuItemIdx) {
      console.log('ipad-menu-click', router, menuIdx, menuItemIdx)
      // 判断当前router 有没有children, 没有children时应直接跳转， 不赋值ipadMenuidx
      if (!router.children || !router.children.length) {
        this.ipadMenuIdx = -1
        this.ipadMenuItemIdx = -1
        this.ipadMenuShow = false
        this.doClearUserActive()
        return this.$router.push({path: router.path})
      }
      this.ipadMenuIdx = menuIdx
      this.ipadMenuItemIdx = menuItemIdx
    },
    // 文档click,scroll事件
    handleDocumentClick (e) {
      let referenceBtn = this.$refs.ipadMenuBtn
      let reference = this.$refs.ipadMenu ? this.$refs.ipadMenu : ''
      if (!referenceBtn ||
        !reference ||
        referenceBtn.contains(e.target) ||
        reference.contains(e.target)) return
      this.ipadMenuShow = false
      this.ipadMenuIdx = -1
      this.ipadMenuItemIdx = -1
      off(document, 'click', this.handleDocumentClick)
    },
    handleDocumentScroll (e) {
      this.ipadMenuShow = false
      this.ipadMenuIdx = -1
      this.ipadMenuItemIdx = -1
      off(document, 'scroll', this.handleDocumentScroll)
    },
    // 清除用户头像下方子菜单状态
    doClearUserActive () {
      this.isPageUser = false
      this.isPageUserhome = false
      this.isPagePlatform = false
    },
    // 微信登录用户登录时未加载数据，利用header渲染时获取数据
    getUserInfo () {
      if (getCookie('iot-session')) {
        this.$store.dispatch('getUserInfo').then(res => {
        }).catch(err => {
          if (!(err.request.readyState === 4 && err.request.status === 0)) {
            this.$store.dispatch('logOut')
          }
        })
        // 获取该用户公告状态
        this.$store.dispatch('checkNoticeStatus')
      } else {
        this.$store.dispatch('cleanCookie')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .header-container{
    position: absolute;
    width: 100%;
    z-index: 1001;
    transition:all .3s;
    &:hover{
      .header-body{
        background: #ffffff;
        .header-body-tools {
          color:#333333;
        }
      }
    }
  }
  .header-body{
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    color: #333;
    transition: all .3s;
    box-shadow:1px 0px 10px rgba(102,102,102,0.1);
    @media screen and (max-width: 1200px) {
      padding: 0 20px;
    }
  }
  .header-body-img {
    .header-logo{
      width: 144px;
      vertical-align: middle;
      margin-right: 20px;
    }
  }
  .header-body-tools{
    height: 60px;
    z-index: 99;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    transition: all .3s;
  }
  .router-list{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @media screen and (max-width: 1000px) {
      display: none;
    }
    .router-item {
      padding: 0 35px;
      cursor: pointer;
      @media screen and (max-width: 1480px) {
        padding: 0 15px;
      }
      &:hover {
        color: #569FFF;
      }
    }
  }
  // 一，二级菜单, 展开
  .router-children-list {
    z-index: 10001;
    width: 100%;
    background-color: #fff;
    height: 0;
    transition: all .3s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    padding: 0 100px;
    color: #374478;
    font-size: 16px;
    @media screen and (max-width: 1200px) {
      padding: 0 20px;
    }
  }
  .router-children-list.active {
    padding: 20px 100px;
    height: 200px;
    box-shadow:1px 0px 10px rgba(102,102,102,0.1);
     @media screen and (max-width: 1200px) {
      padding: 20px 20px;
    }
  }
  // 第一层菜单 产品/配件
  .router-children-layer-first {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .router-children-layer-first
  .router-children-item,
  .router-children-layer-second
  .router-children-item {
    position: relative;
    cursor: pointer;
    width: 25%;
    text-align: left;
    padding: 15px;
  }
  .router-children-layer-first
  .router-children-item
  .router-children-item-content,
  .router-children-layer-second
  .router-children-item
  .router-children-item-content {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .router-children-layer-first
  .router-children-item
  .router-children-item-icon,
  .router-children-layer-second
  .router-children-item
  .router-children-item-icon {
    margin-top: 5px;
    width: 30px;
  }
  .router-children-layer-first
  .router-children-item
  .router-children-item-text,
  .router-children-layer-second
  .router-children-item
  .router-children-item-text {
    margin-left: 10px;
  }
  .router-children-layer-first
  .router-children-item
  .router-children-item-text
  .desc,
  .router-children-layer-second
  .router-children-item
  .router-children-item-text
  .desc {
    font-size: 12px;
    color: #666D8A;
    margin-top: 6px;
  }
  .router-children-layer-first
  .router-children-item:hover,
  .router-children-layer-second
  .router-children-item:hover,
  .router-children-layer-first
  .router-children-item:hover
  .router-children-item-text
  .desc,
  .router-children-layer-second
  .router-children-item:hover
  .router-children-item-text
  .desc {
    color: #569FFF;
  }

  // 存在第二层菜单时的第一层菜单显示样式变动
  .router-children-layer-first.with-second {
    width: 20%;
    border-right: 1px solid #EDEDED;
    flex-direction: column;
    justify-content: center;
  }
  .router-children-layer-first.with-second
  .router-children-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .router-children-layer-first.with-second
  .router-children-item
  .icon-more {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }

  .router-children-layer-first.with-second
  .router-children-item:hover,
  .router-children-layer-first.with-second
  .router-children-item.active {
    color: #569FFF;
    background: #F6F8FB;
  }
  // 第二层菜单
  .router-children-layer-second {
    width: 80%;
    padding: 0 60px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    @media screen and (max-width: 1200px) {
      padding: 0 20px;
    }
  }
  .router-children-layer-second
  .router-children-item {
    width: 33%;
  }
  // 更多菜单 按钮
  .router-ipad {
    background: transparent;
    display: none;
    transition: .3s;
    cursor: pointer;
    @media screen and (max-width: 1000px) {
      display: block;
    }
  }
  // ipad、<1000px 样式菜单
  .router-children-list-ipad {
    z-index: 1001;
    padding: 20px 0;
    max-height: 2000px;
    background-color: #fff;
    box-shadow:1px 0px 10px rgba(102,102,102,0.1);
    transition: all 0.3s;
    display: none;
    @media screen and (max-width: 1000px) {
      display: block;
    }
  }
  // 子菜单默认都不显示
  .router-children-layer-ipad {
    height: 0;
    overflow: hidden;
    width: 100%;
  }
  // 第一层菜单，高度为auto，则可以都显示
  .router-children-list-ipad >.router-children-layer-ipad,
  .router-children-layer-ipad.active {
    height: auto;
  }
  .router-children-layer-ipad
  .router-children-item {
    color: #333333;
    padding: 15px;
    cursor: pointer;
  }
  .router-children-layer-ipad
  .router-children-item
  .router-children-item-content {
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .router-children-layer-ipad
  .router-children-item
  .router-children-item-content
  .router-children-item-icon {
    padding-top: 5px;
    width: 30px;
  }
  .router-children-layer-ipad
  .router-children-item
  .router-children-item-content
  .router-children-item-text {
    margin-left: 10px;
  }

  .router-children-layer-ipad
  .router-children-item
  .icon-more-down {
    margin-left: 20px;
  }
  // 第一层菜单的menuItem, 和已处于打开状态的子菜单的menuItem:hover 才有hover效果
  .router-children-list-ipad >.router-children-layer-ipad
  .router-children-item:hover,
  .router-children-layer-ipad.active
  .router-children-item:hover{
    color: #569FFF;
  }
  .tools-users{
    margin-left: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media screen and (max-width: 1200px) {
      margin-left: 0;
    }
    .tools-users-item{
      margin: 0 20px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      cursor: pointer;
      &:last-child {
        margin-left: 20px;
        margin-right: 0;
      }
      &:hover {
        color: #569FFF;
      }
      .tools-users-item-btn {
        background: #569FFF;
        color: #ffffff;
        border-radius: 4px;
        padding: 10px 20px;
        border: 1px solid #569FFF;
      }
    }
  }
  // 用户下拉菜单，前往个人中心、平台中心等, 语言切换栏
  .sub-router-box{
    position: relative;
    &:hover {
      .sub-router{
        display: block;
      }
    }
    .users-img{
      width: 30px;
      border-radius: 50%;
    }
    .sub-router{
      display: none;
      width: 130px;
      position: absolute;
      left: 50%;
      top: 48px;
      transform: translateX(-50%);
      background: #ffffff;
      box-shadow:0px 4px 16px rgba(80,80,80,0.1);
      border-radius: 2px;
      &.en_mode{
        width: 180px;
      }
    }
    .sub-router-list{
      width: 100%;
      text-align: left;
      font-size: 14px;
      color: #333333;
      overflow: hidden;
      li{
        cursor: pointer;
        padding:0 20px;
        line-height: 2;
        margin-top: 10px;
        &:last-child {
          margin-bottom: 10px;
        }
        i{
          margin-right:8px;
        }
      }
      li:hover,
      li.active{
        color: #569FFF;
        i{
          color: #569FFF;
        }
      }
    }
    &.lang-list {
      min-width: 60px;
      .sub-router-list {
        text-align: center;
      }
    }
  }
  // 通知提醒
  .notice-box{
    position: relative;
    float: left;
    i{
      cursor: pointer;
    }
  }
  .notice-redpoint{
    position: absolute;
    top: 14px;
    right: 1px;
    width: 8px;
    height: 8px;
    background: #FF0000;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue